export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('DISPOSITIF_CAN_NOT_BE_MOVED_IS_ON_CUSTOMER_LOCATION') !== -1) {
        messages.push({
          message: 'detailEmplacement.popupDeplacerDispositif.errors.dispositifCanNotBeMoved',
        });
      }
      if (message.indexOf('DISPOSITIF_CANNOT_BE_MOVED_TO_THIS_LOCATION') !== -1) {
        messages.push({
          message: 'detailEmplacement.popupDeplacerDispositif.errors.dispositifCanNotBeMovedToThisLocation',
        });
      }
    }
  });
}
